import React from "react"
import PropTypes from "prop-types"

export const AlignJustify = ({ height = 18, width = 18, fill = "#272A34", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    stroke={fill}
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M17.5 8.33301H2.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5 5H2.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5 11.667H2.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.5 15H2.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

AlignJustify.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}
